import { CurrencyConverter } from "@components/ui/CurrencyConverter/CurrencyConverter"
import { WeatherWidget } from "@components/ui/WeatherWidget/WeatherWidget"
import { Button, Stack, Switch, Text, Title } from "@mantine/core"
import { useWidgetStore } from "@stores/widgetStore"
import { SHOW_WIDGET_CUSTOMIZE_BUTTON } from "@utils/constants.util"
import styles from "./YourExtensions.module.css"
import { useAEMDictionary } from "@AEM/hooks/useAEMDictionary"

export function YourExtensions() {
	const { dictionary } = useAEMDictionary()
	const { isEditMode, widgetSettings, toggleEditMode, toggleWidget } =
		useWidgetStore()

	return (
		dictionary && (
			<Stack gap="lg" justify="space-between" pt={0} pb="xl" px="xl" h="100%">
				{isEditMode ? (
					<Stack>
						<Title size="sm" fw={600}>
							{dictionary?.widgetCustomizeIntro}
						</Title>
						<Stack gap="xs">
							<Switch
								checked={widgetSettings.weather}
								onChange={() => toggleWidget("weather")}
								label={dictionary?.widgetWeatherTitle}
								size="md"
								classNames={{
									track: widgetSettings.weather
										? styles.switchTrackChecked
										: styles.switchTrackUnchecked,
									thumb: styles.switchThumb
								}}
							/>
							<Text size="xs" c="var(--text-color-grey)" ml={58}>
								{dictionary?.widgetWeatherIntro}
							</Text>
							<Switch
								checked={widgetSettings.currencyConverter}
								onChange={() => toggleWidget("currencyConverter")}
								label={dictionary?.widgetcurrencyTitle}
								size="md"
								classNames={{
									track: widgetSettings.currencyConverter
										? styles.switchTrackChecked
										: styles.switchTrackUnchecked,
									thumb: styles.switchThumb
								}}
							/>
							<Text size="xs" c="var(--text-color-grey)" ml={58}>
								{dictionary?.widgetCurrencyIntro}
							</Text>
						</Stack>
					</Stack>
				) : (
					<Stack>
						{widgetSettings.weather && <WeatherWidget />}
						{widgetSettings.currencyConverter && <CurrencyConverter />}
					</Stack>
				)}

				{SHOW_WIDGET_CUSTOMIZE_BUTTON && (
					<Stack align="center">
						<Button variant="dark-blue" size="lg" onClick={toggleEditMode}>
							{isEditMode
								? dictionary?.widgetSaveButton
								: dictionary?.widgetCustomizeButton}
						</Button>
					</Stack>
				)}
			</Stack>
		)
	)
}
